export default __webpack_public_path__ + "static/media/circles-bg-dark.f3ac3679.svg";